<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <edit-animal-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <animal-detail />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import EditAnimalSideNav from "./components/EditAnimalSideNav.vue"
import AnimalDetail from "./components/AnimalDetail.vue"

export default {
    name: 'Animal_edit_page',
    components: {
        EditAnimalSideNav,
        AnimalDetail
    },
    data() {
        return {
            Id: '',
            animal: [],
            gets: []
        }
    },
    async mounted() {
        
    },
}
</script>